module.exports = __webpack_public_path__ + "img/ep5-4.24ae031e.png";